const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.ADDRESS)
const groupPrefixLogistic = createApiRoute(ApiModule.LOGISTICS, ApiAuthorization.PUBLIC)

export const apiClientAddresses = {
	fetchClientAddresses: async (clientUUID: string): Promise<IClientAddressModel[]> => {
		const { data } = await apiCommon<IClientAddress[]>(`${groupPrefix}/${clientUUID}`, { method: 'GET' })
		return data.map(d => ClientAddress(d))
	},

	createClientAddress: async (payload: IClientAddressCreateModel): Promise<IClientAddressModel> => {
		const body = ClientAddressManageToJson(payload)

		const { data } = await apiCommon<IClientAddress>(`${groupPrefix}/${payload.clientUUID}`, {
			method: 'POST',
			body,
		})

		return ClientAddress(data)
	},

	updateClientAddress: async (payload: IClientAddressUpdateModel): Promise<IClientAddressModel> => {
		const body = ClientAddressManageToJson(payload)

		const { data } = await apiCommon<IClientAddress>(`${groupPrefix}/${payload.uuid}`, {
			method: 'PATCH',
			body,
		})

		return ClientAddress(data)
	},

	deleteClientAddress: async (addressUUID: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/${addressUUID}/hide`, { method: 'POST' })
	},

	fetchHoursForSpecificRegion: async (payload: IRegionPayload): Promise<IRegionCheckResponse> => {
		const { data } = await apiCommon<IRegionCheckResponse>(`${groupPrefixLogistic}/check-region`, {
			method: 'POST',
			body: payload,
		})

		return data
	},
}
